import { css } from '@mvf/product-components/react';

export const useOtherPagesStyles = () => {
  return css({
    container: {
      height: '100vh',
    },
  });
};
